export default __webpack_public_path__ + "images/pdf_64.png";